import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid } from '@hbf/dsl';

const useStyles = makeStyles()(theme => ({
  marginTop: {
    marginTop: theme.spacing(1),
  },
  costName: {
    color: theme.palette.grey[700],
  },
  crossedOutPrice: {
    color: theme.palette.grey[500],
    textDecoration: 'line-through',
    marginLeft: theme.spacing(1),
  },
}));

export interface Props {
  title: string;
  value: string | React.ReactNode;
  crossedValue?: string;
  testLocator?: string;
}

export const CostRow: React.FC<Props> = React.memo(
  ({ title, value, testLocator = undefined, crossedValue }) => {
    const { classes } = useStyles();
    return (
      <Grid
        container
        className={classes.marginTop}
        data-test-locator={testLocator}
      >
        <Grid item xs={6} className={classes.costName}>
          {title}
        </Grid>
        <Grid
          container
          item
          xs={6}
          justifyContent="flex-end"
          alignItems="center"
          className={classes.costName}
        >
          {value}
          {crossedValue && (
            <span className={classes.crossedOutPrice}>{crossedValue}</span>
          )}
        </Grid>
      </Grid>
    );
  },
);
